export const useMapFirstLineIndentToWidth = (value?: number) => {
  if (value === undefined || value === null) return null;

  switch (value) {
    case 0:
      return 0; // no indent
    case 1:
      return 1;
    case 2:
      return 2;
    case 36:
      return 1;
    default:
      // Optional: treat other numbers as px or em as needed
      return Math.ceil(value / 12);
  }
};
